import { useQuery } from '@apollo/client';
import { Button, Card, Col, Form, Input, Row, Space } from 'antd';
import { useState } from 'react';
import { LeftArrow } from '../../assets/svg/index';
import { ROUTES } from '../../common/constants';
import { formValidatorRules } from '../../common/utils';
import PageBreadcrumb from '../../components/PageBreadcrumb';
import history from '../../historyData';
import useRouter from '../../hooks/useRouter';
import { GET_CURRENT_USER } from '../auth/graphql/queries';

const { required, name, email } = formValidatorRules;

function Profile() {
  const [isBtnDisabled, setIsBtnDisabled] = useState<boolean>(true);

  const [form] = Form.useForm();
  const { navigate } = useRouter();

  const { data: userData, loading } = useQuery(GET_CURRENT_USER, {
    fetchPolicy: 'network-only',
    onCompleted({ me }) {
      form.setFieldsValue({
        username: me?.username ?? '',
        email: me?.email ?? '',
      });
    },
  });

  return (
    <>
      <PageBreadcrumb items={[{ title: 'Profile' }]} />
      {userData?.me && (
        <Form
          form={form}
          className="sticky-action-form"
          onValuesChange={() => {
            setIsBtnDisabled(false);
          }}
          layout="vertical"
        >
          <Card
            className="ant-body-scroll"
            title={
              <div className="d-flex align-center">
                <Button
                  icon={<LeftArrow />}
                  type="text"
                  onClick={() => navigate(ROUTES.MAIN)}
                  className="d-flex align-center"
                />
                <h3>Profile</h3>
              </div>
            }
            loading={loading}
            actions={[
              <div key="actionbutton" className="text-right">
                <Space>
                  <Button
                    onClick={() => history.push(ROUTES.MAIN)}
                    size="small"
                    disabled={isBtnDisabled}
                  >
                    Cancel
                  </Button>
                  <Button
                    htmlType="submit"
                    type="primary"
                    disabled={isBtnDisabled}
                    size="small"
                  >
                    Save
                  </Button>
                </Space>
              </div>,
            ]}
          >
            <div className="card-body-wrapper">
              <Row gutter={[16, 16]}>
                <Col xs={24} lg={8} xl={8}>
                  <Form.Item
                    name="username"
                    label="Name"
                    rules={[
                      {
                        ...required,
                        whitespace: true,
                        message: 'Please Enter username Name',
                      },
                      name,
                    ]}
                  >
                    <Input
                      placeholder="Enter username Name"
                      showCount
                      maxLength={50}
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} lg={8} xl={8}>
                  <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                      { ...required, message: 'Please Enter Email' },
                      email,
                    ]}
                  >
                    <Input disabled placeholder="Enter Email" />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </Card>
        </Form>
      )}
    </>
  );
}
export default Profile;
